export enum BackupScope {
    SpecificItems = 2,
    EntireOrganization = 3,
    EntireItem = 4
}
